/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * DifficultTopicDetailsContainer
 *
 * @file DifficultTopicDetailsContainer.jsx
 * @author Gladson Samuel S
 * @since 1.0.0
 */

import React from 'react';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';
import { InternationalSupport } from '@aquila/core';
import ContainerShell from './ContainerShell';
import ErrorBoundary from '../components/common/ErrorBoundary';
import msgObject from '../../translations';
import DifficultTopicDetails from '../components/difficultTopicDetails/DifficultTopicDetails';
import DifficultQuestion from '../components/difficultTopicDetails/DifficultQuestion';
import CustomModal from '../components/common/CustomModal';

const DifficultTopicDetailsContainer = (props) => {
  const intlObj = new InternationalSupport(msgObject, props.locale);

  return (
    <ContainerShell>
      <IntlProvider locale={intlObj.getLocale()} messages={intlObj.getMessages()}>
        <ErrorBoundary>
          <DifficultTopicDetails {...props} />
        </ErrorBoundary>
      </IntlProvider>
    </ContainerShell>
  );
};

DifficultTopicDetailsContainer.propTypes = {
  locale: PropTypes.string
};

DifficultTopicDetailsContainer.defaultProps = {
  locale: 'en'
};

export default DifficultTopicDetailsContainer;
export {
  DifficultQuestion,
  CustomModal
};
